// Auth token cache key. Lives in its own leaf module (no other imports)
// so both src/core/api.ts and src/auth/utils/authSession.ts can read it
// without creating a circular dependency between them.
export const AUTH_TOKEN_CACHE_KEY = 'access_token';
